<template>
    <ui-modal :title="`Price Item ${item.ref}`" :close="delayedClose" no-cancel>
        <estimates-old-page-task-item-price-calculator :item="item" :specs-details="specsDetails"></estimates-old-page-task-item-price-calculator>
        <template #footer-primary>
            <ui-button-new primary class="w-full" @click="delayedClose">Done</ui-button-new>
        </template>
    </ui-modal>
</template>

<script>
import { estimateStore } from '@stores'
import EstimatesOldPageTaskItemPriceCalculator from "./EstimatesOldPageTaskItemPriceCalculator";

export default {
  components: {EstimatesOldPageTaskItemPriceCalculator},
  props: {
        close: Function,
        item: Object,
        specsDetails: Object,
    },
    methods: {
        delayedClose () {
            setTimeout(() => {
                this.close()
            }, 10);
        },
    }
}
</script>
